import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
    namespaced: true,
    state: {
        lstPrs: [],
        prs: null,
        insert: false,
        update: false,
        loading: false,
        itemsPerPage: 20,
        search: "",
        hasNext: false,
        lastUpdatedRegister: null
    },
    getters: {
        getUpdate(state) {
            return state.update
        },
        getPrs(state) {
            return state.prs
        },
        GetPrsgrupo(state) {
            return state.prs.prsgrupo
        },
        getSearch(state) {
            return state.search
        },
        getItemsPerPage(state) {
            return state.itemsPerPage
        },
    },
    mutations: {
        set(state, prs) {
            state.prs = prs
            if (prs)
                state.update = true
        },
        initForm(state) {
            state.insert = false
            state.update = false
            state.prs = null
        },
        setParamsDataTable(state, payload) {
            state.lstPrs = payload.items
            state.itemsPerPage = payload.limit
            state.hasNext = payload.hasNext
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        setPrs(state, prs) {
            state.prs = prs
        },
        setLstPrs(state, lstPrs) {
            state.lstPrs = lstPrs
        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext
        },
        setSearch(state, search) {
            state.search = search
        },
        setLastUpdatedRegister(state, lastUpdatedRegister) {
            state.lastUpdatedRegister = lastUpdatedRegister
        },
    },
    actions: {
        initForm({ commit }) {
            commit("initForm")
        },
        async find({ commit, dispatch }, { prsgrupo }) {
            commit("setLoading", true)
            commit("initForm")
            await this._vm.$axios.get(`/Products/Group/Find/${prsgrupo}`)
                .then(response => {
                    let prs = Utils.ValidateAxiosResponse(response.data);
                    commit("set", prs)
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                });
            commit("setLoading", false)
        },
        async save({ dispatch, getters }) {
            if (getters.getUpdate) {
                return await dispatch("update")
            }
            return await dispatch("insert")
        },
        async insert({ commit, dispatch, getters }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.post("/Products/Group/Insert", getters.getPrs)
                .then(response => {
                    commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
                    commit("setPrs", null)
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload
        },
        async update({ dispatch, commit, getters }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.put("/Products/Group/Update", getters.getPrs)
                .then(response => {
                    commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
                    commit("setPrs", null)
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload
        },
        async delete({ dispatch, getters }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, { root: true })
            await this._vm.$axios.delete(`/Products/Group/Delete/${getters.GetPrsgrupo}`)
                .then(response => {
                    Utils.ValidateAxiosResponse(response.data);
                    router.push("/oryxpdv/produto-grupos")
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
        },
        async findList({ commit, dispatch, getters }) {
            commit("setLoading", true)
            commit("initForm")
            await this._vm.$axios.get(`/Products/Group/FindList`)
                .then(response => {
                    let lstPrs = Utils.ValidateAxiosResponse(response.data);
                    commit("setLstPrs", lstPrs)
                    commit("setHasNext", lstPrs.length > getters.getItemsPerPage)
                }).catch(error => {
                    commit("setLstPrs", [])
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                })
            commit("setLoading", false)
        },
        async search({ commit, dispatch, getters }, { limit = 20, page = 1 }) {
            commit("setLoading", true)
            commit("initForm")
            let payload = await this._vm.$axios.get(`/Products/Group/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`)
                .then(response => {
                    let payload = Utils.ValidateAxiosResponse(response.data);
                    commit("setParamsDataTable", payload)
                    return true
                })
                .catch((error) => {
                    commit("setLstPrs", [])
                    commit("setSearch", [])
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            commit("setLoading", false)
            return payload
        },
    }
}